export function isPdfDocumentFileType(fileType: string | undefined): boolean {
  if (!fileType) {
    return false;
  }

  const normalizedFileType = fileType.toLowerCase();
  return (
    normalizedFileType === 'pdf' ||
    normalizedFileType === '.pdf' ||
    normalizedFileType === 'application/pdf'
  );
}
